var handle_array = ["electrolux-central-vacuum-main-power-unit-model-elx600-with-30-foot-hose-kit","2020-beam-serenity-limited-edition-650aw-000374","pure-and-clean-air-purifier-and-surface-purifier-proven-to-nullify-sars-cov-2-plugs-in-to-wall","air-scrubber-by-aerus-air-and-surface-purifier-ozone-free-fits-heat-ac-ductwork","air-scrubber-mobile-by-aerus-certified-space-technology™️-surface-air-cleaner","automatic-x4-black-w-4-piece-value-pack-onyx-collection","automatic-x7-premium-pet-upright-vacuum-black-onyx-collection","classic-series-sc275-central-vacuum-beam","felix-premium-upright-vacuum-black-onyx-collection","austin-air-healthmate-hm450-hepa-air-purifier-sandstone","sebo-airbelt-d4-premium-canister-vacuum-black-onyx-collection","sebo-airbelt-e3-premium-canister-vacuum-black-onyx-collection","sebo-91542am-automatic-x7-premium-upright-vacuum-cleaner-graphite-w-brush-mode","sebo-airbelt-k3-premium-canister-vacuum-black-5-piece-onyx-collection","tube","aerus-electrolux-central-vacuum-cone-separator-with-gasket","aerus-electrolux-genuine-circuit-board-part-number-46777","dvc-to-fit-aerus-electrolux-c-style-canister-100-pack-vacuum-bags","hose-for-aerus-electrolux-upright-vacuum","upright-vacuum-hose-for-aerus-electrolux","central-vacuum-power-unit-only-md-model-airmaster-model-a650tv-120-volt"];
 var productid_array = ["5880990662806","5991522893974","5991542096022","5991552549014","6009584189590","6009618268310","5881138741398","6009633669270","5737197207702","6009681772694","6009657098390","6031490941078","6009667354774","6838444425366","6734165377174","7327884476566","5815773397142","6058366402710","6912813301910","7357383344278"];
 var collectionid_array = [""];
 var product_tags_array = [""];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=1;
 var phone_no = '801-372-1149';
 var display_call_for_price = 1;
 var call_for_price_label = 'Call for Price 801-372-1149';
 var css_style_button='background-color: #000000;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = '801-372-1149';
 var comment_label = 'Comment';
 var submit_label ='Submit';
  var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = '801-372-1149';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='';
 var cart_selector='#AddToCart-product-template';
  var phone_no_label = 'Call for Price: 801-372-1149';
 var required_field='phone';
 var contact_form_heading='Call for Price for 801-372-1149 Vacuum Dr';
 var parent_selector='';
 var unavailable_label='Unavailable';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='no';
 var enable_cfp_for_all_products='no';
 var enable_cfp_soldout_products='no';
 var hide_cfp_btn_on_collection='yes';
 var hide_phone_no_on_collection='no';
 var enable_whatsapp = 0;
 var whatsapp_number = '';
 var whatsapp_message = '';
 var hide_whatsapp_button_on_collection = 0;
 var whatsapp_button_text ='';
 var whatsapp_button_background_color ='#000000';
 var whatsapp_button_text_color ='#ffffff';
 var whatsapp_css_style_button ='';
 var phoneno_css_style_button ='';